// src/utils/analyticsUtils.js

import parseDuration from "./parseDuration";

// สรุปข้อมูล Pie chart แสดงเวลารวม, จำนวน, เฉลี่ย/ครั้ง ของแต่ละหมวด
export function getPieDetails(activities, categories, lang) {
  return categories.map(cat => {
    const acts = activities.filter(a => a.category === cat.value);
    const totalMin = acts.reduce((sum, a) => sum + parseDuration(a.duration), 0);
    const count = acts.length;
    return totalMin > 0 ? {
      label: cat.label[lang],
      color: cat.color,
      totalHour: +(totalMin / 60).toFixed(2),
      count,
      avgHour: count > 0 ? +(totalMin / 60 / count).toFixed(2) : 0,
    } : null;
  }).filter(Boolean);
}